module.exports = __webpack_public_path__ + "static/media/logo-camara-comercio-tunja.5589b09f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sponsorsLogos/logo-camara-comercio-tunja.png
// module id = 343
// module chunks = 0